import React, { useState } from 'react';
import theme from '../../theme';

export default function Select({ label, options = [], style, id, ...rest }) {
  const [focused, setFocused] = useState(false);
  const selectId = id || rest.name || label;
  return (
    <div style={{ width: '100%' }}>
      {label && (
        <label htmlFor={selectId} style={{ display: 'block', fontSize: 11, fontWeight: 600, color: theme.text2, marginBottom: '6px' }}>
          {label}
        </label>
      )}
      <select
        id={selectId}
        onFocus={(e) => { setFocused(true); rest.onFocus?.(e); }}
        onBlur={(e) => { setFocused(false); rest.onBlur?.(e); }}
        style={{
          width: '100%',
          minHeight: '44px',
          padding: '0 14px',
          fontSize: 13,
          fontFamily: theme.fontBody,
          color: theme.text1,
          background: theme.surface2,
          border: `1px solid ${focused ? theme.gold : theme.border2}`,
          borderRadius: theme.r2,
          outline: 'none',
          boxSizing: 'border-box',
          cursor: 'pointer',
          transition: 'all 0.15s',
          boxShadow: focused ? theme.focusRing : 'none',
          ...style,
        }}
        {...rest}
      >
        {options.map(opt => (
          typeof opt === 'string'
            ? <option key={opt} value={opt}>{opt}</option>
            : <option key={opt.value} value={opt.value}>{opt.label}</option>
        ))}
      </select>
    </div>
  );
}
